import React from "react";
import Swal from "sweetalert2";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import EditIcon from "@mui/icons-material/Edit";
import { construirResumenComparativo, formatearValor, esVacio } from "../../Helpers/ResumenComparativoHelper";

// ResumenComparativoHDEquip
// Tabla comparativa HD vs EQUIP por registro (Concepto / Información /
// Observaciones / Acción). Botón "Modificar" solo si el ID Cliente no
// coincide en ambos lados. Detalle largo: ver CHANGELOG_2026-08.md.
export const ResumenComparativoHDEquip = ({
  titulo = "RESUMEN COMPARATIVO",
  registros,
  sufijoEquip = "_facturacion",
  onModificarIdCliente,
  // Conceptos a omitir de la tabla (ej. ["idequip"] cuando no aplica validar ID Cliente).
  conceptosExcluidos = [],
}) => {
  const grupos = construirResumenComparativo(registros, sufijoEquip, conceptosExcluidos);

  const onClickModificar = (idcliente) => {
    onModificarIdCliente(idcliente)
  };

  if (grupos.length === 0) {
    return null;
  }

  return (
    <div className="resumen-comparativo-hd-equip">
      <div className="resumen-comparativo-hd-equip-header">
        <div className="resumen-comparativo-hd-equip-header-titulo">
          <FactCheckIcon /> {titulo}
        </div>
        <div className="resumen-comparativo-hd-equip-header-leyenda">
          <span className="resumen-comparativo-hd-equip-leyenda-item resumen-comparativo-hd-equip-leyenda-item-success">
            <CheckCircleIcon /> Coincide
          </span>
          <span className="resumen-comparativo-hd-equip-leyenda-item resumen-comparativo-hd-equip-leyenda-item-error">
            <ErrorIcon /> No coincide
          </span>
        </div>
      </div>

      <div className="resumen-comparativo-hd-equip-grupos scroll-4">
        {grupos.map((grupo) => (
          <div className="resumen-comparativo-hd-equip-grupo" key={grupo.identificador}>
            <div
              className={
                grupo.coincideTodo
                  ? "resumen-comparativo-hd-equip-grupo-titulo resumen-comparativo-hd-equip-grupo-titulo-success"
                  : "resumen-comparativo-hd-equip-grupo-titulo resumen-comparativo-hd-equip-grupo-titulo-error"
              }
            >
              {grupo.coincideTodo ? <CheckCircleIcon /> : <ErrorIcon />}
              {grupo.identificador}
            </div>

            <table cellPadding={0} cellSpacing={0}>
              <thead>
                <tr>
                  <th>Concepto</th>
                  <th>Información</th>
                  <th>Observaciones</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {grupo.conceptos.map((item) => (
                  <tr
                    key={item.concepto}
                    className={
                      item.esCorrecto
                        ? "resumen-comparativo-hd-equip-fila-success"
                        : "resumen-comparativo-hd-equip-fila-error"
                    }
                  >
                    <td className="resumen-comparativo-hd-equip-celda-concepto">
                      {item.etiqueta}
                    </td>
                    <td>{formatearValor(item.hd)}</td>
                    <td>{item.observacion}</td>
                    <td>
                      {item.concepto === "idequip" &&
                        !item.esCorrecto &&
                        !esVacio(item.hd) &&
                        !esVacio(item.equip) ? (
                        <div
                          className="resumen-comparativo-hd-equip-boton-modificar"
                          onClick={() => onClickModificar(item.equip)}
                        >
                          <EditIcon /> Modificar
                        </div>
                      ) : null}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </div>
    </div>
  );
};
